import { compose, branch, renderComponent } from 'recompose';

const NonOptimalStates = states =>
  compose(...states.map(state =>
    branch(state.when, renderComponent(state.render))));

export default NonOptimalStates;



// WEBPACK FOOTER //
// ./src/app/hoc/NonOptimalStates.js